// Resolve Shopify asset paths
function shopifyAsset(path) {
  if (!path) return '';
  if (path.startsWith('http')) return path;
  if (path.startsWith('SHOPIFY_ASSET:')) path = path.replace('SHOPIFY_ASSET:', '');
  if (path.startsWith('assets/products/')) path = 'products-' + path.replace('assets/products/','');
  if (path.startsWith('assets/categories/')) path = 'categories-' + path.replace('assets/categories/','');
  if (path.startsWith('assets/pdp-vv/')) path = 'pdp-vv-' + path.replace('assets/pdp-vv/','');
  if (path.startsWith('assets/')) path = path.replace('assets/','');
  // Change .png to .jpg for compressed files (except svg)
  if (!path.endsWith('.svg') && !path.startsWith('http')) {
    path = path.replace(/\.(png|webp)$/, '.jpg');
  }
  return (window.SHOPIFY_CDN || '') + path;
}
window.shopifyAsset = shopifyAsset;
/* ============================================================
   DAULATRAM'S — populate data-driven sections
   ============================================================ */
(function () {
  const U = "https://daulatrams.com/wp-content/uploads/";
  const rpc = window.renderProductCard;
  const P = window.__PRODUCTS || {};
  const fb = "this.style.visibility='hidden'";

  /* Marquee */
  const marquee = [
    "Proudly Made in India", "100% Ayurvedic Formula", "No Chemical Additives",
    "FSSAI Certified", "Third Generation Heritage", "5,000+ Happy Customers",
    "Free Shipping on ₹1000+", "Zero Side Effects", "Cold-Pressed & Natural", "Trusted Since Decades"
  ];
  const mTrack = document.getElementById("marquee-track");
  if (mTrack && mTrack.children.length === 0) {
    const one = marquee.map((t) => `<span class="m-item"><span class="dot">◆</span> ${t}</span>`).join("");
    mTrack.innerHTML = one + one;
  }

  /* Categories — real product preview images */
  const cats = [
    { name: "Bestsellers",       image: (window.SHOPIFY_CDN||'')+'products-desi-cow-ghee.jpg', url: "shop.html#all-products" },
    { name: "Men\'s Wellness",    image: (window.SHOPIFY_CDN||'')+'products-veer-ved-shakti-60.jpg', url: "shop.html?cat=mens-wellness" },
    { name: "Women\'s Wellness",  image: (window.SHOPIFY_CDN||'')+'products-nari-kalp.jpg', url: "shop.html?cat=womens-wellness" },
    { name: "Desi Ghee",         image: (window.SHOPIFY_CDN||'')+'products-a2-cow-desi-ghee.jpg', url: "shop.html?cat=desi-ghee" },
    { name: "Honey",             image: (window.SHOPIFY_CDN||'')+'products-van-tulsi-honey.jpg', url: "shop.html?cat=honey" },
    { name: "Hair Care",         image: (window.SHOPIFY_CDN||'')+'products-real-herbs-oil.jpg', url: "shop.html?cat=hair-care" },
    { name: "Skin Care",         image: (window.SHOPIFY_CDN||'')+'products-natural-aloevera-gel.jpg', url: "shop.html?cat=skin-care" },
    { name: "Cold Pressed Oils", image: (window.SHOPIFY_CDN||'')+'products-coconut-oil.jpg', url: "shop.html?cat=cold-pressed-oils" },
    { name: "Wellness",          image: (window.SHOPIFY_CDN||'')+'products-moringa-capsules.jpg', url: "shop.html?cat=wellness" },
    { name: "Weight Loss",       image: (window.SHOPIFY_CDN||'')+'products-slim-tea.jpg', url: "shop.html?cat=weight-loss" },
    { name: "Shilajit",          image: (window.SHOPIFY_CDN||'')+'products-shilajit-drop.jpg', url: "shop.html?q=shilajit" },
    { name: "Kitchen & Home",    image: (window.SHOPIFY_CDN||'')+'products-desi-gud.jpg', url: "shop.html?cat=kitchen-%26-home" }
  ];
  const catGrid = document.getElementById("cat-grid");
  // Skip if Liquid already rendered categories
  if (catGrid && catGrid.children.length === 0) {
    catGrid.innerHTML = cats.map((c) => `
      <a class="cat-card cat-card-photo" href="${c.url.replace('shop.html#all-products','/collections/all').replace(/shop\.html\?cat=/,'/collections/').replace('shop.html','/collections/all')}" aria-label="${c.name}">
        <div class="cat-photo-wrap"><img class="cat-photo" src="${shopifyAsset(c.image)}" alt="${c.name}" loading="lazy" onerror="this.style.display='none'"></div>
        <div class="cat-name">${c.name}</div>
        <div class="cat-arrow">→</div>
      </a>`).join("");
  }

  /* New arrivals, bestsellers, Men's Wellness, Hair Care, and Skin Care
     carousels are all rendered server-side by their own Liquid sections
     (home-bestsellers.liquid, home-mens-wellness.liquid, etc.) directly
     from real Shopify collections — always live, always the full set.
     This used to overwrite that correct markup with a hardcoded, stale
     product-handle list (window.__CATALOG), which silently dropped any
     handle the list didn't have an entry for. Removed entirely. */

  /* Concern default tab */
  const cg = document.getElementById("concern-grid");
  if (cg) {
    const MAP = {
      "hair-care": "Hair Care",
      "skin-care": "Skin Care",
      "mens-wellness": "Men's Wellness",
      "womens-wellness": "Women's Wellness",
      "weight-loss": "Weight Loss",
      "desi-ghee": "Desi Ghee",
      "honey": "Honey"
    };
    const filtered = catalog.filter(p => (p.category || '').toLowerCase() === "hair care");
    cg.innerHTML = filtered.slice(0, 8).map(rpc).join("");
  }

  /* Spotlight ingredient pills — 14 ancient herbs with thumbnails */
  const pillWrap = document.getElementById("ingredient-pills");
  if (pillWrap) {
    const ingD = window.__INGREDIENTS || {};
    pillWrap.innerHTML = Object.values(ingD).map((h) => `
      <span class="pill pill-herb" title="${h.name} · ${h.dose || ""}">
        <span>${h.name}</span>
      </span>`).join("");
  }

  /* Spotlight pack selector */
  const packSel = document.getElementById("spot-pack");
  if (packSel) {
    const upd = () => {
      const o = packSel.options[packSel.selectedIndex];
      const price = +o.dataset.price, orig = +o.dataset.orig, save = +o.dataset.save, off = +o.dataset.off, id = o.dataset.id;
      const $ = (s) => document.getElementById(s);
      $("spot-price").textContent = "₹" + price.toLocaleString("en-IN");
      $("spot-orig").textContent = "₹" + orig.toLocaleString("en-IN");
      $("spot-save").textContent = `SAVE ₹${save.toLocaleString("en-IN")} · ${off}% OFF`;
      const lbl = document.getElementById("spot-buy-label");
      if (lbl) lbl.textContent = `BUY NOW — GET ${off}% OFF`;
      else { const off2 = $("spot-off"); if (off2) off2.textContent = off; }
      $("spot-buy").href = "product.html?id=" + id;
      $("spot-cart").href = "product.html?id=" + id;
      const is60 = (o.value === "60");
      const fg = $("spot-free-gift");
      const gOv = $("spot-gift-overlay");
      if (fg) fg.hidden = !is60;
      if (gOv) gOv.hidden = !is60;
    };
    packSel.addEventListener("change", upd);
    upd();
  }

  /* Testimonials */
  const testimonials = [
    { name: "Priya Sharma", city: "Delhi", avatar: shopifyAsset("testi-priya-sharma-v2.jpg"), rating: 5, product: "Nari Kalp",
      text: "After my second child, I felt drained all the time. Nari Kalp brought my energy back so gently and naturally. It honestly feels like the Ayurveda my grandmother believed in — but made for today." },
    { name: "Rohit Verma", city: "Lucknow", avatar: shopifyAsset("testi-rohit-verma-v2.jpg"), rating: 5, product: "Shakti+ Capsules",
      text: "I was sceptical about Ayurvedic supplements, but Shakti+ proved me wrong. By the third week my stamina at the gym and through the workday improved noticeably. No jitters, no crashes." },
    { name: "Gurpreet Singh", city: "Chandigarh", avatar: shopifyAsset("testi-gurpreet-singh-v2.jpg"), rating: 5, product: "Shakti+ Capsules",
      text: "Trusted brand, honest formula. You can feel the purity. My father and I both take it now — that says everything about how much our family trusts Daulatram\'s." },
    { name: "Megha Patil", city: "Pune", avatar: shopifyAsset("testi-megha-patil-v2.jpg"), rating: 5, product: "Desi Cow Ghee",
      text: "The Desi Cow Ghee tastes exactly like the one we got from our village. Pure aroma, golden colour, no shortcuts. It has become a staple in my kitchen for the whole family." },
    { name: "Mahesh Joshi", city: "Jaipur", avatar: shopifyAsset("testi-mahesh-joshi-v2.jpg"), rating: 5, product: "Pain Relief Oil",
      text: "At 58, my knee pain used to slow me down every morning. The pain oil gives real, warm relief within minutes. Heritage knowledge that actually works — I\'m grateful." }
  ];
  const tStars = (n) => "★★★★★".slice(0, n) + "☆☆☆☆☆".slice(0, 5 - n);
  const tTrack = document.getElementById("testi-track");
  if (tTrack) tTrack.innerHTML = testimonials.map((t) => `
    <div class="testi-card">
      <div class="quote-mark">“</div>
      <p class="review">${t.text}</p>
      <div class="stars">${tStars(t.rating)}</div>
      <div class="testi-foot">
        <img src="${t.avatar}" alt="${t.name}" loading="lazy" onerror="this.src='data:image/svg+xml;utf8,<svg xmlns=%22http://www.w3.org/2000/svg%22 width=%2252%22 height=%2252%22><rect width=%2252%22 height=%2252%22 fill=%22%23EDE0C8%22/></svg>'">
        <div><div class="name">${t.name}</div><div class="city">${t.city}</div></div>
      </div>
      <span class="testi-prod">Used: ${t.product}</span>
    </div>`).join("");

  /* Values */
  const ic = (d) => `<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8">${d}</svg>`;
  const values = [
    { t: "100% Natural", d: "Pure plant-based ingredients, zero chemicals, zero compromise.", i: '<path d="M11 20A7 7 0 0 1 4 13c0-5 7-11 7-11s7 6 7 11a7 7 0 0 1-7 7z"/><path d="M11 20v-9"/>' },
    { t: "Own Manufacturing", d: "Produced in our own Karnal facility under expert supervision.", i: '<path d="M3 21h18M4 21V9l5-3 5 3M14 21V9l6-3v15"/>' },
    { t: "Science Backed", d: "Ancient wisdom validated by modern research and FSSAI standards.", i: '<path d="M9 2h6M10 2v6l-5 9a2 2 0 0 0 2 3h10a2 2 0 0 0 2-3l-5-9V2"/>' },
    { t: "3 Generations of Trust", d: "Decades of Ayurvedic expertise passed down through our family.", i: '<circle cx="9" cy="7" r="3"/><circle cx="17" cy="9" r="2.4"/><path d="M3 21c0-3.3 2.7-6 6-6s6 2.7 6 6M15 21c0-2.5 1.8-4.6 4-5"/>' },
    { t: "Pan-India Delivery", d: "Reaching 19,000+ pincodes with fast, trackable shipping.", i: '<path d="M1 3h15v13H1zM16 8h4l3 3v5h-7"/><circle cx="5.5" cy="18.5" r="1.8"/><circle cx="18.5" cy="18.5" r="1.8"/>' },
    { t: "Easy Returns", d: "Quality guarantee — full refund if you’re not satisfied.", i: '<path d="M3 12a9 9 0 1 1 3 6.7M3 12V7M3 12h5"/>' },
    { t: "Secure Payments", d: "UPI, Card, COD — 128-bit SSL encrypted checkout.", i: '<rect x="4" y="10" width="16" height="11" rx="2"/><path d="M8 10V7a4 4 0 0 1 8 0v3"/>' },
    { t: "24/7 Support", d: "WhatsApp & phone support — we’re always here for you.", i: '<path d="M22 16.9v3a2 2 0 0 1-2.2 2 19.8 19.8 0 0 1-8.6-3 19.5 19.5 0 0 1-6-6 19.8 19.8 0 0 1-3-8.6A2 2 0 0 1 4.1 2h3a2 2 0 0 1 2 1.7c.4 2.5 1.2 3.4.5 4.3L8.1 9.9a16 16 0 0 0 6 6l1.9-1.5c.9-.7 1.8.1 4.3.5a2 2 0 0 1 1.7 2z"/>' }
  ];
  const vGrid = document.getElementById("values-grid");
  if (vGrid) vGrid.innerHTML = values.map((v) => `
    <div class="value-card">
      <div class="v-ico">${ic(v.i)}</div>
      <h3>${v.t}</h3>
      <p>${v.d}</p>
    </div>`).join("");

  /* Ingredients list */
  const ingData = window.__INGREDIENTS || {};
  const keys = Object.keys(ingData);
  window.renderIngredientDetail = function (d) {
    if (!d) return "";
    const visual = d.image
      ? `<img src="${shopifyAsset(d.image)}" alt="${d.name}" loading="lazy">`
      : (d.emoji || "");
    return `
      <div class="ing-vis${d.image ? " ing-vis-img" : ""}">${visual}</div>
      <div>
        <h3>${d.name}</h3>
        <div class="sanskrit">${d.sanskrit || ""}${d.dose ? ` · <b>${d.dose}</b>` : ""}</div>
        <p class="ing-desc">${d.desc}</p>
        <div class="ing-tags">${(d.tags || []).map((t) => `<span>${t}</span>`).join("")}</div>
        <div class="ing-used">Used in: <b>${d.used}</b></div>
      </div>`;
  };
  const ingList = document.getElementById("ing-list");
  if (ingList) {
    ingList.innerHTML = keys.map((k, i) => `
      <button class="ing-item${i === 0 ? " active" : ""}" data-ing="${k}">
        <span class="ing-dot"></span>${ingData[k].name}
      </button>`).join("");
    const d = ingData[keys[0]];
    const detail = document.getElementById("ing-detail");
    if (detail) detail.innerHTML = window.renderIngredientDetail(d);
  }

  /* Media logos */
  const logos = ["FSSAI", "Made in India", "AYUSH Ministry", "GMP Certified", "ISO 9001", "Swadeshi", "Cruelty Free", "Lab Tested"];
  const lTrack = document.getElementById("logos-track");
  if (lTrack) {
    const chip = (l) => `<div class="logo-chip"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8"><path d="m9 12 2 2 4-4"/><circle cx="12" cy="12" r="9"/></svg>${l}</div>`;
    const one = logos.map(chip).join("");
    lTrack.innerHTML = one + one;
  }
})();




